import { useState } from "react";
import { logError, LogCategory } from "utils/sentryLogger";

export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);

      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      logError("LocalStorage read failed", error, {
        category: LogCategory.ERROR,
        storageKey: key,
      });
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      logError("LocalStorage write failed", error, {
        category: LogCategory.ERROR,
        storageKey: key,
      });
      console.log(error);
    }
  };

  return [storedValue, setValue];
};
